import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutZoneAreaList extends Layout {
    labelSearchZoneArea: Label;
    mapRoute: Map;
    sourceZoneArea: DataSource;
    splitterZoneArea: Splitter;
    tableZoneAreaList: Table;
}
